<template>
  <div class="container-fluid">
    <div class="row">
      <side-bar v-if="period" :period="period"></side-bar>
      <main role="main" class="col-md-10 ml-sm-auto col-lg-10 fill page">
        <timeline
          v-if="period"
          ref="timeline"
          chartId="timeline"
          :siteIDs="siteIDs"
          :isOnlyOneSite="isOnlyOneSite"
          :start="startDate"
          :end="endDate"
          @update="onDateRangeUpdate"
        ></timeline>
        <component
          v-bind:is="componentName"
          :period="period"
          v-if="period"
          @updateSite="onUpdateSite"
        ></component>
      </main>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { utilsMixin, timeMixin } from '../../utils/mixins'

export default {
  name: 'Default',
  mixins: [utilsMixin, timeMixin],
  data() {
    return {
      startDate: null,
      endDate: null,
      period: null,
      isOnlyOneSite: false,
      siteIDs: [],
    }
  },
  components: {
    timeline: () => import('../Timeline'),
    'side-bar': () => import('../Sidebar'),
    dashboard: () => import('../Dashboard'),
    comment: () => import('../Comment'),
    maps: () => import('../Map'),
    survey: () => import('../Survey'),
    device: () => import('../Device'),
    batterygradient: () => import('../BatteryGradient'),
    areas: () => import('../Area'),
  },
  computed: {
    componentName() {
      return this.$route.name.toLowerCase()
    },
  },
  async mounted() {
    let start = this.getDate('start')
    let end = this.getDate('end')

    if (start.isAfter(end) || end.isBefore(start)) {
      end = start.add(1, 'day')
    }

    this.startDate = start
    this.endDate = end
    this.period = [start.format(this.dateFormat), end.format(this.dateFormat)]

    //Checking available filters and filters values for current user
    const response = await axios.get(`${this.$baseURL}/config/filters`)
    let filters = response.data.result

    let user = this.$store.getters['auth/user']

    //Removing filters and filters values for partners
    if (user.userRole.name == 'partner') {
      filters.filter_values.site_location = Array.from(user.sites, site => {
        return site.site
      })

      let customFilters = filters.custom
      let updatedCustomFilters = {}
      for (const key in customFilters) {
        if (filters.filter_values.site_location.indexOf(key) > -1) {
          updatedCustomFilters[key] = customFilters[key]
        }

        if (updatedCustomFilters[key]) {
          delete updatedCustomFilters[key]['site']
          delete updatedCustomFilters[key]['version']
          delete updatedCustomFilters[key]['player_version']
          delete updatedCustomFilters[key]['os_version']
          delete updatedCustomFilters[key]['os_name']
          delete updatedCustomFilters[key]['os_build']
          delete updatedCustomFilters[key]['device_model']
          delete updatedCustomFilters[key]['device_vendor']
        }
      }

      delete filters.filter_values['site']
      delete filters.filter_values['version']
      delete filters.filter_values['player_version']
      delete filters.filter_values['os_version']
      delete filters.filter_values['os_name']
      delete filters.filter_values['os_build']
      delete filters.filter_values['device_model']
      delete filters.filter_values['device_vendor']
      delete filters.filter_values['state']
      delete filters.filter_values['bucket']
      delete filters.filter_values['warning_type']

      filters.custom = updatedCustomFilters
    }

    //Save new filters and filters values configuration
    await this.$store.dispatch('config/setCurrentFiltersConfig', filters)
  },
  methods: {
    getDate: function(dateParam) {
      if (
        this.$route.params[dateParam] &&
        moment(this.$route.params[dateParam], 'YYYYY-MM-DD').isValid()
      ) {
        return moment(this.$route.params[dateParam], 'YYYYY-MM-DD')
      } else {
        if (this.getCurrentPeriod) {
          if (dateParam == 'start') {
            const savedStart = moment(this.getCurrentPeriod[0], this.dateFormat)
            if (!savedStart.isValid()) {
              return moment().subtract(1, 'month')
            } else {
              return savedStart
            }
          } else {
            const savedEnd = moment(this.getCurrentPeriod[1], this.dateFormat)
            if (!savedEnd.isValid()) {
              return moment()
            } else {
              return savedEnd
            }
          }
        } else {
          if (dateParam == 'start') {
            return moment().subtract(1, 'month')
          } else {
            return moment()
          }
        }
      }
    },
    onDateRangeUpdate: function(dateRange) {
      if (typeof this.startDate !== 'string' || typeof this.startDate !== 'string') {
        this.startDate = moment(this.startDate, 'YYYY-MM-DD').format(this.dateFormat)
        this.endDate = moment(this.endDate, 'YYYY-MM-DD').format(this.dateFormat)
      }

      clearTimeout(this.timeout)

      this.startDate = dateRange.start
      this.endDate = dateRange.end

      this.timeout = setTimeout(async () => {
        if (
          this.period &&
          moment(this.period[0], this.dateFormat).isSame(this.startDate) &&
          moment(this.period[1], this.dateFormat).isSame(this.endDate)
        ) {
          return
        }

        this.period = [
          moment(this.startDate).format(this.dateFormat),
          moment(this.endDate).format(this.dateFormat),
        ]

        if (
          moment(this.period[0], this.dateFormat).isValid() &&
          moment(this.period[1], this.dateFormat).isValid()
        ) {
          await this.saveCurrentPeriod(this.period)
        }
      }, 300)
    },
    onUpdateSite: function(sites) {
      if (sites && sites.length) {
        this.isOnlyOneSite = sites.length == 1 && sites[0] && sites[0] !== 'all'
        this.siteIDs = sites
      } else {
        this.isOnlyOneSite = false
      }
    },
  },
}
</script>
